export default "__VITE_ASSET__BrL22BoJ__"